import React from "react";

const CreditMaster = () => {
  return (
    <div className="page-content">
      <div className="container-fluid">
        <h2>CreditMaster</h2>
        <p>Content for CreditMaster page will go here.</p>
      </div>
    </div>
  );
};

export default CreditMaster;
